import { useContext } from 'react';
import { FabMenuContext } from './fabMenuContext';

export function useFabMenu() {
  const context = useContext(FabMenuContext);
  if (!context) {
    throw new Error('useFabMenu must be used within FabMenuProvider');
  }
  return context;
}
